import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="booking-type-reason"
export default class extends Controller {
  static targets = [
    "reasonSelect",
    "otherReasonSection",
    "otherReasonInput",
    "manualConfirmationInput",
    "confirmButton",
    "summarySelectContainer",
    "summarySelectValue",
    "summaryOtherInfoContainer",
    "summaryOtherInfoValue"
  ]

  connect() {
    this.enableButton();
    this.addManualConfirmationListener();
  }
  
  toggleOtherReasonSection() {
    const required = this.reasonSelectTarget.options[this.reasonSelectTarget.selectedIndex].getAttribute('data-reason-required');
    if (required === "true") {
      this.otherReasonSectionTarget.classList.add("open");
    } else {
      this.otherReasonSectionTarget.classList.remove("open");
    }
    this.updateSummarySelect();
  }

  enableButton() {
    const required = this.reasonSelectTarget.options[this.reasonSelectTarget.selectedIndex].getAttribute('data-reason-required');
    const selectValue = this.reasonSelectTarget.value;
    const reason = this.otherReasonInputTarget.value;
    const checkbox = this.manualConfirmationInputTarget.querySelector('#booking_manual_confirmation_understood');
    const checkboxChecked = checkbox && checkbox.checked;
    if (selectValue && selectValue !== "" && required !== 'true') {
      this.confirmButtonTarget.classList.remove("btn-disabled");
    } else if (required == 'true' && reason.trim() !== "" && checkboxChecked) {
      this.confirmButtonTarget.classList.remove("btn-disabled");
    } else {
      this.confirmButtonTarget.classList.add("btn-disabled");
    }
  }

  addManualConfirmationListener() {
    if (this.manualConfirmationInputTarget) {
      const checkbox = this.manualConfirmationInputTarget.querySelector('#booking_manual_confirmation_understood');
      if (checkbox) {
        checkbox.addEventListener("change", () => this.enableButton() );
      }
    }
  }

  // SUMMARY FUNCTIONS

  updateSummarySelect() {
    const selectedOption = this.reasonSelectTarget.options[this.reasonSelectTarget.selectedIndex];
    const required = selectedOption.getAttribute('data-reason-required');
    const value = selectedOption ? selectedOption.text : "";
    this.summarySelectValueTarget.textContent = value;
    this.toggleSummarySelectContainer(value);
    this.toggleSummaryOtherInfoContainer(required);
  }

  toggleSummarySelectContainer(value) {
    if (value && value !== "" && value !== "Select...") {
      this.summarySelectContainerTarget.classList.add("open");
    } else {
      this.summarySelectContainerTarget.classList.remove("open");
    }
  }  

  updateSummaryOtherInfo() {
    const info = this.otherReasonInputTarget.value.trim();
    this.summaryOtherInfoValueTarget.textContent = info;
    this.toggleSummaryOtherInfoContainer();
  }

  toggleSummaryOtherInfoContainer(required) {
    if (!required) {
      required = this.reasonSelectTarget.options[this.reasonSelectTarget.selectedIndex].getAttribute('data-reason-required');
    }
    if (required === "true") {
      this.summaryOtherInfoContainerTarget.classList.add("open");
    } else {
      this.summaryOtherInfoContainerTarget.classList.remove("open");
    }
  }


}
